module.exports = __webpack_public_path__ + "img/home.e7b8301a.jpg";